'use strict';

module.exports = 1000;


//////////////////
// WEBPACK FOOTER
// ./node_modules/sugar/common/var/INTERNAL_MEMOIZE_LIMIT.js
// module id = 620
// module chunks = 1